module.exports = __webpack_public_path__ + "static/media/road-F-photo.19790719.svg";